<template>
  <div class="detail-header">
    <div class="first-line flex">
      <div class="item flex">
        <img :src="setSexPhoto(detailsObj.sex)">
        <span>{{ detailsObj.name }}</span>
      </div>
      <div class="item">
        <span>招募评价：</span>
        <span> {{ detailsObj.comprehensiveScore }}</span>
      </div>
      <div class="item">
        <span>当前评价：</span>
        <span> {{ detailsObj.nowComprehensiveScore }}</span>
      </div>
      <div class="item">
        <span>当前状态：</span>
        <span> {{  getCurrentStage(detailsObj.lifeNode) }}</span>
      </div>
      <div class="item">
        <span>性向测试状态：</span>
        <span> {{  getTestResult(detailsObj.doneTest) }}</span>
      </div>
    </div>
    <el-descriptions :column="5" :colon="false">
      <el-descriptions-item label="证件类型：">{{ getCardName(detailsObj.certiType) }}</el-descriptions-item>
      <el-descriptions-item label="证件号码：">{{ detailsObj.certiCode }}</el-descriptions-item>
      <el-descriptions-item label="联系电话：">{{ detailsObj.mobile }}</el-descriptions-item>
      <el-descriptions-item label="所属机构：">{{ detailsObj.organName }}/{{ detailsObj.areaName }}</el-descriptions-item>
      <el-descriptions-item label="推荐人：">{{ detailsObj.recomAgentcode }}-{{ detailsObj.recomName }}</el-descriptions-item>
    </el-descriptions>
    <el-divider></el-divider>
  </div>
</template>
<script>

import { Options } from '@/components/utils/fixOptions'
export default {
  props: {
    detailsObj: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      stepList: Options.step_all_status,
      cardTypes: Options.id_type,

    };
  },
  methods: {
    getCardName(val){
      return val ? this.cardTypes.find(ite=>ite.value == val).label : ''
    },
    getCurrentStage(node){
      return node ? this.stepList.find(ite=>ite.value == node).label : ''
    },
    getTestResult(doneTest){
      return doneTest == '1' ? '是' : '否'
    },
    setSexPhoto(sex){
      let img = sex == '1' ? 'man' : 'woman'
      return require("../../../../assets/account/" + img + ".png")
    }
  },
};
</script>
<style lang="scss" scoped>
.detail-header {
  .flex {
    display: flex;
    align-items: flex-end;
  }

  .first-line {
    margin: 0 0 30px;
    .item {
      width: 25%;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/component/detailHeader.vue